//import _ from 'underscore';
import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./CEW.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import ViewModelUtil from 'edge/gw-portals-bop-components-angular/node_modules/gw-portals-viewmodel-js/ViewModelUtil.js';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            hideForm: '&',
            periodData: '=',
            saveCoveredEmployees: '&',
            perCapitaClasses: '=?',
            portalCoveredEmployees: '=',
            jobNumber: '=',
            locationMissing: '=',
            policyQuoted: '=',
            errorInSubmission: '='
        },
        controller: ['$scope', '$rootScope', 'RenewalService', 'ModalService', 'ViewModelService', '$state', '$filter', 'PolicyService', 'CancellationService', function ($scope, $rootScope, RenewalService, ModalService, ViewModelService, $state, $filter, PolicyService, CancellationService) {
            $rootScope.addEditedClassCodeList = [];
            $scope.portalCoveredEmployees = $rootScope.portalCoveredEmployees;
            console.log($scope.portalCoveredEmployees);
            $scope.renewalComplete = false;
            $scope.selectedEntry = -1;
            //DEF0932-GHC-Portal-In CCEW.js in the code $scope.employee = ViewModelService.create
            $scope.employeeView = ViewModelService.create({}, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
            /**
            * Function to retrieve a list of Class codes based on job number from RenewalService
            * @param {String} jobNumber - The id for job number
            * @returns {Array} - List of Class Codes
            * @private
            */
            var lookupCodesPromise = RenewalService.getAllClassCodes($scope.jobNumber);
            console.log('per capita in CEW');
            /**
             * Function to retrieve a list of PerCapita Class codes based on job number from PolicyService
             * @param {String} jobNumber - The id for job number
             * @returns {Array} - List of PerCapita Class Codes
             * @private
             */
            PolicyService.getPerCapitaCodesByJobNumber($scope.jobNumber).then(function (datas) {
                $scope.perCapitaClasses = [];
                if (datas.length > 0) {
                    angular.forEach(datas, function (data) {
                        $scope.perCapitaClasses.push(data.classCode);
                    });
                }
                console.log($scope.perCapitaClasses);
            });
            /**
            * Function to search and retrieve a class code based on user entered value.
            * @param {String} userinput - The class code
            * @returns {Array} - List of Class Codes based on matching value entered by user
            * @private
            **/
            $scope.classcodeLookup = {
                getMatches: function getMatches(userinput) {
                    return lookupCodesPromise.then(function (propertyCodes) {
                        return _(propertyCodes).filter(function (code) {
                            return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Error retrieving property class code', 'gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                    });
                },
                toString: function toString(code) {
                    if (ViewModelUtil.isViewModelNode(code)) {
                        return code.value;
                    }
                    return PropertyCodeUtil.toString(code);
                },
                directive: PropertyCodeViewDirective
            }; //end of Classcode lookup

            $scope.coveredEmployees = angular.copy($scope.periodData.mSFWCCoveredEmployees);
            $scope.selectedEntry = -1;

            //adding new class
            /**
            * Function called when user adds a new class.
            * @param {none}
            * @returns {none} - Emits an event to let other containers to disable CEWQuote,
                                sets isAdding flag to true,
                                creates a newEmployee element and corresponding ViewModel,
                                updates aspects on a newEmployeeLocation View object. sets value to null.
            * @private
            */
            $scope.addClass = function () {
                $scope.isAddingNew = true;$scope.$emit("disableCEWQuote");
                $scope.newEmployee = {
                    basisAmount: null,
                    classCode: '',
                    description: '',
                    location: '',
                    noOfEmployees: null,
                    perCapita: null,
                    suffix: ''
                };
                $scope.employeeView = ViewModelService.create($scope.newEmployee, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                console.log("inside add class");
                console.log($scope.periodData);
                //setting up location options
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.periodData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        }
                    },
                    value: ''
                };
            };
            /**
             * Function called when user Edits an existing Class
             * @param {integer} - index of selected element
             * @param {Object} - employeesData
             * @param {String} - type
             * @returns {none} - Emits an event to let other containers to disable CEWQuote,
                                 sets isAdding flag to false,
                                 sets isEditing flag to true,
                                 sets the employeeView Model object with the selected element's passed in employeesData object,
                                 updates aspects on a newEmployeeLocation View object. sets value to $scope.employeeView.location.value
             * @private
             */
            $scope.onEdit = function (index, employeesData, type) {
                $scope.selectedType = type;
                $scope.isAddingNew = false;$scope.$emit("disableCEWQuote");
                $scope.isEditing = true;
                $scope.selectedEntry = index;
                $scope.resetErrors();
                //setting up location
                $scope.employeeView = ViewModelService.create(employeesData[index], 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.periodData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.employeeView.location.value;
                        }
                    },
                    value: $scope.employeeView.location.value
                };
            }; //end of onEdit

            /**
            * Function called to reset sattus flags for all Errors objects  - errors, and employee Errors -
            *                                                                 location, classCode, moreSuffix, noOfEmployees, basis, perCapita
            * @param {none}
            * @returns {none} - updates scope object with errors and employee errors.
            * @private
            */
            $scope.resetErrors = function () {
                $scope.errors = false;
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('Number of employees should be in the range between 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('Please use Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('Please use  only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
            };
            /**
             * Function to set currency to usd
             * @param {String} val
             * @returns {Object} - set amount and currency values for the Vm object
             * @private
             */
            $scope.toCurrency = function (val) {
                return { amount: val, currency: 'usd' };
            };
            //setting cursor at the starting
            //service to check risk id availability
            $scope.$watch('employeeView.value.classCode', function (newVal) {
                var classCode = document.getElementById('gwClassCode');
                if (classCode != null && classCode.querySelector("textarea").value.length > 10) {
                    var input = classCode.querySelector("textarea");
                    //for IE
                    if (input.createTextRange) {
                        console.log('in first loop');
                        var part = input.createTextRange();
                        part.moveEnd("character", 0);
                        part.moveStart("character", 0);
                        part.select();
                    } else if (input.setSelectionRange) {
                        console.log('in second loop');
                        input.setSelectionRange(0, 0);
                    }
                }
                //update suffix error
                if (newVal != null && newVal != undefined) {
                    if (newVal.mSFClassIndicator == '00') {
                        RenewalService.getClassCodeBycode(newVal.code, $scope.jobNumber).then(function (data) {
                            if (data.length > 1) {
                                $scope.moreSuffix = true;
                            } else $scope.moreSuffix = false;
                        });
                    } else $scope.moreSuffix = false;
                } else $scope.moreSuffix = false;
            });
            //validate duplicate class code available or not
            $scope.validateDuplicateClassCode = function () {
                //use logic in seperate method
                console.log($scope.employeeView);
                console.log($scope.portalCoveredEmployees);
                console.log("emp view");
                $scope.isDuplicateAvailable = false;
                angular.forEach($scope.periodData.mSFWCCoveredEmployees, function (eachFirst, firstRecord) {

                    console.log("first record classcode");
                    console.log(eachFirst.classCode.code);
                    console.log($scope.employeeView.classCode.value.code);
                    console.log("first record location");
                    console.log(eachFirst.location.locationDisplayName);
                    console.log($scope.employeeView.location.value.locationDisplayName);
                    console.log("classcode indicator");
                    console.log(eachFirst.classCode.mSFClassIndicator);
                    console.log($scope.employeeView.classCode.value.mSFClassIndicator);
                    if (eachFirst.classCode.code == $scope.employeeView.classCode.value.code && eachFirst.location.locationDisplayName == $scope.employeeView.location.value.locationDisplayName && eachFirst.classCode.mSFClassIndicator == $scope.employeeView.classCode.value.mSFClassIndicator) {
                        $scope.isDuplicateAvailable = true;
                        console.log($scope.isDuplicateAvailable);
                    }
                });

                //new record
                angular.forEach($scope.portalCoveredEmployees, function (eachSecond, secondRecord) {
                    console.log("sec record classcode");
                    console.log(eachSecond.classCode.code);
                    console.log($scope.employeeView.classCode.value.code);
                    console.log("sec record location");
                    console.log(eachSecond.location.locationDisplayName);
                    console.log($scope.employeeView.location.value.locationDisplayName);
                    console.log("sec classcode indicator");
                    console.log(eachSecond.classCode.mSFClassIndicator);
                    console.log($scope.employeeView.classCode.value.mSFClassIndicator);
                    if (eachSecond.classCode.code == $scope.employeeView.classCode.value.code && eachSecond.location.locationDisplayName == $scope.employeeView.location.value.locationDisplayName && eachSecond.classCode.mSFClassIndicator == $scope.employeeView.classCode.value.mSFClassIndicator) {
                        $scope.isDuplicateAvailable = true;
                        console.log($scope.isDuplicateAvailable);
                    }
                });
                console.log("duplicate available");
                console.log($scope.isDuplicateAvailable);
                return $scope.isDuplicateAvailable;
            };
            //update employee errors
            /**
            * Function to update employee errors, to watch for decimals for number of employees, class codes with suffixes etc.
            * @param {none} val
            * @returns {none} - sets the message based on validation error type
            * @private
            */
            $scope.updateEmployeeErrors = function (type) {
                if (type != 'existing' && type != 'portal') {
                    $scope.isDuplicate = $scope.validateDuplicateClassCode();
                    console.log("isDuplicate");
                    console.log($scope.isDuplicate);
                }
                var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Number of employees should be within the range of 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') },
                    duplicate: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages. Class code already exists at location.') }
                };
                //check no of employee error
                if (type != 'existing' && type != 'portal' && $scope.isDuplicate) {
                    $scope.employeeErrors.duplicate.status = true;
                    $scope.employeeErrors.duplicate.message = $filter('translate')(" Class code " + "  " + $scope.employeeView.classCode.value.code + "-" + $scope.employeeView.classCode.value.mSFClassIndicator + " " + "already exists at location" + " " + $scope.employeeView.location.value.locationDisplayName + ".");
                }
                if ($scope.employeeView.noOfEmployees.value !== '' && $scope.employeeView.noOfEmployees.value !== null && $scope.employeeView.noOfEmployees.value !== undefined) {
                    if (validNumber.test($scope.employeeView.noOfEmployees.value) === false || $scope.employeeView.noOfEmployees.value % 1 !== 0 || $scope.employeeView.noOfEmployees.value < 1 || $scope.employeeView.noOfEmployees.value > 2147483647) {
                        $scope.employeeErrors.noOfEmployees.status = true;
                        $scope.employeeErrors.noOfEmployees.message = $filter('translate')('Number of Employees should be within the range of 1 to 2147483647 without decimal.');
                    }
                }
                //checking location error
                if (!$scope.employeeView.value.location) {
                    $scope.employeeErrors.location.status = true;
                } else if (!$scope.employeeView.value.classCode) {
                    $scope.employeeErrors.classCode.status = true;
                } else if ($scope.moreSuffix) {

                    $scope.employeeErrors.moreSuffix.status = true;

                    $scope.employeeErrors.moreSuffix.message = $scope.employeeView.value.classCode.code + ' selected class contains more than one suffix. 00 suffix may not be used.';
                } else {
                    //setting up percapita is mandatory based on selected class code
                    if ($scope.perCapitaClasses && $scope.perCapitaClasses.indexOf($scope.employeeView.value.classCode.code) != -1) {
                        if ($scope.employeeView.perCapita.value === '' || validNumber.test($scope.employeeView.perCapita.value) === false || $scope.employeeView.perCapita.value % 1 !== 0 || $scope.employeeView.perCapita.value < 0 || $scope.employeeView.perCapita.value > 2147483647) {
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.value.basisAmount !== '' && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== undefined && $scope.employeeErrors.perCapita.status === false) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    } else {
                        if ($scope.employeeView.value.basisAmount === '' || validNumber.test($scope.employeeView.value.basisAmount) === false || $scope.employeeView.value.basisAmount % 1 !== 0 || $scope.employeeView.value.basisAmount < 0 || $scope.employeeView.value.basisAmount > 2147483647) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.perCapita.value !== '' && $scope.employeeView.perCapita.value !== null && $scope.employeeView.perCapita.value !== undefined && $scope.employeeErrors.basis.status === false) {
                            console.log($scope.employeeView.perCapita.value);
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    }
                }
            }; //End of updateEmployeeErrors
            /**
             * Function to check employee error status
             * @param {None} - checks values from $scope.employeeErrors.
             * @returns {None} - sets $scope.displayEmployeeError.
             * @private
             */
            $scope.checkEmployeeErrors = function () {
                $scope.displayEmployeeError = false;
                angular.forEach($scope.employeeErrors, function (error) {
                    if (error.status === true) {
                        $scope.displayEmployeeError = true;
                        return;
                    }
                });
                return $scope.displayEmployeeError;
            };
            //save in portal
            /**
             * Function executed when save button is clicked. If no employee Errors exist, populate the values of basisAmout, perCapita based on user entry.
             * @param {String} - type - existing or portal
             * @returns {boolean} - If $scope.errors is false the function returns false, otherwise, populates required $scope variables with values.
             * @private
             */
            $scope.onSave = function (type) {
                console.log("type");
                console.log(type);
                $scope.updateEmployeeErrors(type);
                if ($scope.checkEmployeeErrors() != true) {
                    if ($scope.employeeView.value.basisAmount === '' || $scope.employeeView.value.basisAmount === null || $scope.employeeView.value.basisAmount === undefined) delete $scope.employeeView.value.basisAmount;
                    if ($scope.employeeView.value.perCapita === '' || $scope.employeeView.value.perCapita === null || $scope.employeeView.value.perCapita === undefined) delete $scope.employeeView.value.perCapita;
                    if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.employeeView.value.noOfEmployees;
                    //Round up decimal places
                    if ($scope.employeeView.value.noOfEmployees !== '' && $scope.employeeView.value.noOfEmployees !== null && $scope.employeeView.value.noOfEmployees !== undefined) $scope.employeeView.noOfEmployees.value = Math.round($scope.employeeView.noOfEmployees.value);
                    if ($scope.employeeView.value.basisAmount !== undefined && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== '') {
                        $scope.employeeView.value.basisAmount = Math.round($scope.employeeView.value.basisAmount);
                    }
                    if ($scope.employeeView.value.perCapita !== undefined && $scope.employeeView.value.perCapita !== null && $scope.employeeView.value.perCapita !== '') $scope.employeeView.value.perCapita = Math.round($scope.employeeView.value.perCapita);
                    if ($scope.selectedEntry > -1) {
                        var alreadyExisting = $rootScope.addEditedClassCodeList.find(function (a) {
                            return a.classCode.code == $scope.employeeView.value.classCode.code;
                        });
                        if (alreadyExisting) {
                            alreadyExisting = angular.extend({}, alreadyExisting, $scope.employeeView.value);
                        } else {
                            $rootScope.addEditedClassCodeList.push($scope.employeeView.value);
                        }
                        if (type == 'existing') {
                            console.log("existing");
                            //console.log($scope.employeeView.value);
                            if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].noOfEmployees;else $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].noOfEmployees = $scope.employeeView.value.noOfEmployees;
                            if ($scope.employeeView.value.basisAmount === '' || $scope.employeeView.value.basisAmount === null || $scope.employeeView.value.basisAmount === undefined) delete $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].basisAmount;else {
                                $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].basisAmount = $scope.employeeView.value.basisAmount;
                                console.log($scope.periodData);
                            }
                            if ($scope.employeeView.value.perCapita === '' || $scope.employeeView.value.perCapita === null || $scope.employeeView.value.perCapita === undefined) delete $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].perCapita;else $scope.periodData.mSFWCCoveredEmployees[$scope.selectedEntry].perCapita = $scope.employeeView.value.perCapita;
                        }
                        if (type == 'portal') $scope.coveredEmployees[$scope.selectedEntry] = $scope.employeeView.value;
                    } else {
                        //update employeeView
                        $rootScope.addEditedClassCodeList.push(angular.extend({}, $scope.employeeView.value, { isNew: true }));
                        if (angular.isDefined($scope.portalCoveredEmployees) && $scope.portalCoveredEmployees != null && $scope.portalCoveredEmployees.length > 0) {
                            $scope.portalCoveredEmployees.push($scope.employeeView.value);
                        } else {
                            console.log("newwwww");
                            $scope.portalCoveredEmployees = [$scope.employeeView.value];
                        }
                    }
                    $scope.selectedEntry = -1;
                    $scope.$emit("enableCEWQuote");
                    $scope.isAddingNew = false;
                    $scope.isEditing = false;
                } else {
                    $scope.errors = true;
                    return false;
                }
                $rootScope.portalCoveredEmployees = $scope.portalCoveredEmployees;
                console.log($rootScope.portalCoveredEmployees);
            }; // End of onSave
            /**
             * Function called when a row is removed
             * @param {integer} index - the selected item
             * @returns {object} - emits an even to enable CEWQuote,set isAddingNew to false, isEditing to false and resets Errors
             * @private
             */
            $scope.onRemove = function (index) {
                if (index !== 'new' && $scope.portalCoveredEmployees) $scope.portalCoveredEmployees.splice(index, 1);$scope.$emit("enableCEWQuote");
                $scope.isAddingNew = false;
                $scope.isEditing = false;
                $scope.resetErrors();
            };
            /**
              * Function executed to submit values for portalCoveredEmployees and existing Employees. calls saveCoveredEmployees method
              * @param {None} uses values from $scope object.
              * @returns {Object} - set amount and currency values for the Vm object
              * @private
              */
            $scope.onSubmit = function () {
                console.log('in submit now');
                console.log($scope.portalCoveredEmployees);
                $scope.saveCoveredEmployees({ data: { portalcoveredEmployees: $scope.portalCoveredEmployees, existingEmployees: $scope.periodData.mSFWCCoveredEmployees } });
            };
        }] // end Controller     
    }; // end return
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/CEWDirective/CEW.js
// module id = 1730
// module chunks = 0